import { Component, OnInit, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { ApirequestService } from '../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../services/api-urls/apiurls.service';
import { UtilityService } from '../../../services/utilities/utilities.services';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'hybse-admin-activity-logs',
  templateUrl: './activity-logs.component.html',
  styleUrls: ['./activity-logs.component.css']
})
export class ActivityLogsComponent implements OnInit {

  showLoader: boolean = true;
  public activitiesLog: any = [];
  public completeLogs: any = [];
  activitiesLogCount: any = 0;
  pageOffset: number = 0;
  pageLimit: number = 20;
  error: string;
  activityFilterForm: FormGroup;
  activityCodes: any = [];
  filterData: any = {
    username: '',
    activityCode: ''
  };
  public commissonLogs: any[];
  public type: string
  public commissionErrorMessage: string;
  public orderMatchesErrorMessage: string;
  public activityLogErrorMessage: string

  constructor(
    private _req: ApirequestService,
    private _url: ApiurlsService,
    private _utils: UtilityService,
    private _cdr: ChangeDetectorRef,
    private _fb: FormBuilder,
    public toastr: ToastsManager, vcr: ViewContainerRef,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.data.subscribe(
      (data: any) => {
        this.type = data.type;
      });
    this.toastr.setRootViewContainerRef(vcr);
  }



  ngOnInit() {
    this.getActivitiesLog(this.pageOffset, this.pageLimit);
    this.getActivityCode();
    this.activityFilterFormInit();
    if(this.type){
      this.getCommissonLogs();
      this.getOrderMatchesList();
    }
  }
  activityFilterFormInit() {
    this.activityFilterForm = this._fb.group({
      'username': [''],
      'activityCode': ['']
    });
  }
  getActivitiesLog(offset, limit) {
    this.showLoader = true;
    let data = {
      offset: offset,
      limit: limit,
      data: this.filterData
    }
    this._req.fetchApiData(this._url.activityLogsUrl, data).subscribe(
      (data: any) => {
        let resSucc = data.data;

        let resErr = data.error;
        if (resSucc != '') {
          this.showLoader = false;
          if (resSucc.userActivityList.length) {
            this.activitiesLog = resSucc.userActivityList;
            this.activitiesLogCount = resSucc.userActivityLogCount;
          } else {
            if (resErr != '') this.activityLogErrorMessage = resErr.errorDescription;
            this.showSuccess();
          }

          // this.activitiesLog = this._utils.paginatedItems(resSucc,0,this.pageSize);
          // this.pageListOriginal = resSucc;
        }
      },
      error => {

      },
      () => {

      }
    )
  }

  getActivityCode() {
    this._req.fetchApiData(this._url.activityCodeUrl, {}, 'get').subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resErr = data.error;
        if (resSucc != '') {
          this.activityCodes = resSucc;
        }
        // if(resErr != '') this.activityLogErrorMessage=resErr.errorDescription;
      },
      error => {

      },
      () => {

      }
    )
  }

  getCommissonLogs() {
    let url = (this.type) ? this._url.demoCommissionLogListUrl : this._url.commissionLogListUrl;
    this._req.fetchApiData(url, {}).subscribe(
      (data: any) => {
        console.log('commisstion', data);
        let resSucc = data.data;
        let resErr = data.error;
        if (resSucc != '') this.commissonLogs = resSucc.commissionLogList;
        if (resErr != '') this.commissionErrorMessage = resErr.errorDescription;

      },
      error => {

      },
      () => {

      })
  }


  getOrderMatchesList() {
    let url = (this.type) ? this._url.demoOrderMatchesListUrl : this._url.orderMatchesListUrl;
    this._req.fetchApiData(url, {}).subscribe(
      (data: any) => {
        console.log('Activity logvfghf', data);
        let resSucc = data.data;
        let resErr = data.error;
        if (resSucc != '') {
          this.completeLogs = resSucc.orderMatchesList;
        } else {
          this.orderMatchesErrorMessage = resErr.errorDescription;
        }
      },
      error => {

      },
      () => {

      })
  }


  filterLogs(form) {
    let formVal = this.activityFilterForm.value;
    let username = formVal.username;
    let codes = formVal.activityCode;
    this.filterData = formVal;
    this.getActivitiesLog(this.pageOffset, this.pageLimit);
  }

  /* Pagination */
  paginateContent(e) {
    console.log(e);
    let pageIndex = e.pageIndex;
    let pageSize = e.pageSize;
    let offset = pageIndex * pageSize;
    //alert(offset);
    this.getActivitiesLog(offset, this.pageLimit);
  }

  showSuccess() {
    this.toastr.success('You are awesome!', 'Success!');
  }

  showError() {
    this.toastr.error('This is not good!', 'Oops!');
  }

  showWarning() {
    this.toastr.warning('You are being warned.', 'Alert!');
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/activity-logs/activity-logs.component.ts